// import { Button, TagBox } from 'devextreme-react';
// import {
//     Column,
//     Grouping,
//     GroupItem,
//     GroupPanel,
//     Item,
//     Lookup,
//     Summary,
//     Toolbar
// } from 'devextreme-react/data-grid';
// import _ from 'lodash';
// import moment from 'moment';
// import React, { useEffect, useRef, useState } from 'react';
// import { toast } from 'react-toastify';
// import { Col, FormGroup, Label, Row } from 'reactstrap';
// import Breadcrumb from '../../components/common/breadcrumb';
// import DatagridCustom from '../../components/common/datagrid/custom-datagrid';
// import api from '../../services/api-configuration';
// import { getAllWarehouses } from '../../services/apis';
// import { ButtonOnExporting } from '../../utils/DataGridExporter';
// import useFormatMessage from '../../utils/useFormatMessage';
// // Constants
// const TYPE_LOOKUP = [
//     { value: "milli", name: "Evet" },
//     { value: "ithal", name: "Hayır" }
// ];

// const PDI_ORDER_LOOKUP = [
//     { value: "YENİ", name: "Evet" },
//     { value: "IPTAL", name: "İptal" },
//     { value: "YOK", name: "Hayır" }
// ];
// // Validation functions
// const isBrandValid = (brandName, validBrands) => {
//     return validBrands.some(b => b.brand_name === brandName);
// };

// const isColorValid = (colorName, brandName, validColors) => {
//     return validColors.some(c =>
//         c.color_name === colorName &&
//         c.brand_name === brandName
//     );
// };

// // Check nested items functions
// const checkNestedItemsBrand = (items, validBrands) => {
//     if (!items || !Array.isArray(items)) {
//         return true;
//     }

//     return items.every(item => {
//         if (item.Data) {
//             const isValid = isBrandValid(item.Data.marka, validBrands);
//             if (!isValid) return false;
//         }

//         if (item.items && Array.isArray(item.items)) {
//             return checkNestedItemsBrand(item.items, validBrands);
//         }

//         if (item.collapsedItems && Array.isArray(item.collapsedItems)) {
//             return checkNestedItemsBrand(item.collapsedItems, validBrands);
//         }

//         return true;
//     });


// };

// const checkNestedItemsColor = (items, field, validColors) => {
//     if (!items || !Array.isArray(items)) {
//         return true;
//     }

//     return items.every(item => {
//         if (item.Data) {
//             const isValid = isColorValid(item.Data[field], item.Data.marka, validColors);
//             if (!isValid) return false;
//         }

//         if (item.items && Array.isArray(item.items)) {
//             return checkNestedItemsColor(item.items, field, validColors);
//         }

//         if (item.collapsedItems && Array.isArray(item.collapsedItems)) {
//             return checkNestedItemsColor(item.collapsedItems, field, validColors);
//         }

//         return true;
//     });
// };


// // Render functions
// const getTotalCount = (items) => {
//     let count = 0;
//     if (!items) return count;

//     if (!Array.isArray(items)) {
//         if (items.Data) {
//             return 1;
//         }
//         return count;
//     }

//     for (let item of items) {
//         if (item.items) {
//             count += getTotalCount(item.items);
//         } else if (item.collapsedItems) {
//             count += getTotalCount(item.collapsedItems);
//         } else {
//             count += 1;
//         }
//     }
//     return count;
// };

// const findFirstValue = (items, field) => {
//     if (!items) return " - ";

//     if (!Array.isArray(items)) {
//         return items.Data?.[field] || " - ";
//     }

//     if (items.length === 0) return " - ";

//     const item = items[0];
//     if (item.Data && item.Data[field]) {
//         return item.Data[field];
//     }
//     if (item.items && item.items.length > 0) {
//         return findFirstValue(item.items, field);
//     }
//     if (item.collapsedItems && item.collapsedItems.length > 0) {
//         return findFirstValue(item.collapsedItems, field);
//     }
//     return " - ";
// };

// const renderGroupCellBrand = (items, validBrands) => {
//     const allValid = checkNestedItemsBrand(items, validBrands);
//     const color = allValid ? "black" : "red";
//     const value = findFirstValue(items, 'marka');
//     const count = getTotalCount(items);

//     return (
//         <span>
//             Marka: &nbsp;
//             <span style={{ color }}>
//                 {value}
//             </span>
//             ({count})
//         </span>
//     );
// };

// const renderGroupCellColor = (field, items, validColors) => {
//     const allValid = checkNestedItemsColor(items, field, validColors);
//     const color = allValid ? "black" : "red";
//     const value = findFirstValue(items, field);
//     const count = getTotalCount(items);

//     return (
//         <span>
//             {field === "colour name" ? "Renk" : field}: &nbsp;
//             <span style={{ color }}>
//                 {value}
//             </span>
//             ({count})
//         </span>
//     );
// };

// const renderCellColor = (value, data, validColors) => {
//     const color = isColorValid(value, data.Data.marka, validColors) ? "black" : "red";
//     return (
//         <span style={{ color }}>
//             {value || ''}
//         </span>
//     );
// };

// // Filter expression creator
// const createFilterExpression = (knownItems, itemField) => (filterValue, selectedFilterOperation, target) => {
//     // Arama fonksiyonu için özel durum
//     if (target === 'search' && typeof filterValue === 'string') {
//         return [itemField, 'contains', filterValue];
//     }

//     // Data path'i oluştur
//     const dataPath = itemField.includes('[')
//         ? itemField.replace('[', '.').replace(']', '')
//         : itemField;

//     // "MARKA YOK" veya "RENK YOK" kontrolü
//     if (filterValue === "MARKA YOK" || filterValue === "RENK YOK") {
//         return data => {
//             // Data objesi yoksa true dön
//             if (!data.Data) return true;

//             // Değeri al
//             const fieldValue = _.get(data, `Data.${dataPath}`);

//             // Tüm olası boş değer durumlarını kontrol et
//             return fieldValue == null ||
//                 fieldValue === undefined ||
//                 fieldValue === "" ||
//                 fieldValue === "null" ||
//                 fieldValue === "undefined" ||
//                 typeof fieldValue === "undefined";
//         };
//     }

//     // BİLİNMEYEN değerler için kontrol
//     if (filterValue === "BİLİNMEYEN") {
//         return data => {
//             const fieldValue = _.get(data, `Data.${dataPath}`);
//             const brandValue = _.get(data, 'Data.marka');

//             //marka ve renk ikisine de bak al, marka yoksa true dön
//             if (!fieldValue && !brandValue) return true;

//             // Değer boş olmamalı ve bilinen değerler listesinde olmamalı
//             const isNotEmpty = fieldValue != null &&
//                 fieldValue !== undefined &&
//                 fieldValue !== "" &&
//                 fieldValue !== "null" &&
//                 fieldValue !== "undefined";

//             return isNotEmpty && !knownItems.includes(fieldValue);
//         };
//     }

//     // Normal filtre işlemi için
//     return data => {
//         const fieldValue = _.get(data, `Data.${dataPath}`);

//         // Boş değer kontrolü
//         if (fieldValue == null || fieldValue === undefined) {
//             return false;
//         }

//         // Eşitlik kontrolü
//         if (selectedFilterOperation === '=' || !selectedFilterOperation) {
//             return fieldValue === filterValue;
//         }

//         // Contains operatörü için
//         if (selectedFilterOperation === 'contains' && fieldValue) {
//             return fieldValue.toString().toLowerCase().includes(filterValue.toLowerCase());
//         }

//         return true;
//     };
// };
// // Custom Hook
// const useVehicleData = () => {
//     const [dataSource, setDataSource] = useState([]);
//     const [brands, setBrands] = useState([]);
//     const [colors, setColors] = useState([]);
//     const gridRef = useRef(null);

//     const fetchBrands = async () => {
//         try {
//             const response = await api.post("/getAllBrands");
//             setBrands(response.data.data || []);
//         } catch (error) {
//             let errorMessage = error.response?.data?.error || "";
//             toast.error(`Markalar getirilirken hata oluştu: ${errorMessage}`);
//             console.error("Error fetching brands:", error);
//         }
//     };

//     const fetchColors = async () => {
//         try {
//             const response = await api.post("/getAllColors");
//             setColors(response.data.data || []);
//         } catch (error) {
//             let errorMessage = error.response?.data?.error || "";
//             toast.error(`Renkler getirilirken hata oluştu: ${errorMessage}`);
//             console.error("Error fetching colors:", error);
//         }
//     };

//     const getAllVehicles = async () => {
//         gridRef.current.instance.beginCustomLoading();
//         try {
//             const response = await api.post('/vehicle/getAll', {
//                 "warehouse_ids": [],
//                 "zone_ids": [],
//                 "models": [],
//                 "brands": [],
//             });
//             let datas = response.data || [];
//             setDataSource(datas);
//         } catch (error) {
//             let errorMessage = error.response?.data?.error || "";
//             toast.error(`Şaseler getirilirken hata oluştu: ${errorMessage}`);
//             console.error("Failed to fetch vehicles:", error);
//         } finally {
//             gridRef.current.instance.endCustomLoading();
//         }
//     };

//     useEffect(() => {
//         fetchBrands();
//         getAllVehicles();
//         fetchColors();
//     }, []);

//     return { dataSource, brands, colors, getAllVehicles, gridRef };
// };

// // Component
// const VehicleList = () => {
//     const { t } = useFormatMessage();

//     const { dataSource, brands, colors, getAllVehicles, gridRef } = useVehicleData();
//     const [warehouse, setWarehouse] = useState([]);
//     const [zone, setZone] = useState([]);
//     const [model, setModel] = useState([]);

//     const fetchModels = async () => {
//         try {
//             const response = await api.post("/getAllModels");
//             setModel(response.data.data || []);
//         } catch (error) {
//             let errorMessage = error.response?.data?.error || "";
//             toast.error(t('Modeller getirilirken hata oluştu') + ":" + errorMessage);
//             console.error("Error fetching models:", error);
//         }
//     };
//     useEffect(() => {
//         fetchModels();
//     }, []);

//     const handleRowPrepared = (e) => {
//         if (e.rowType === "group" && e.values[e.groupIndex] === "") {
//             e.rowElement.hidden = true;
//             if (!e.isExpanded) e.component.expandRow(e.key);
//         }
//         if (e.rowType === "data" && e.data.color) {
//             e.rowElement.style.fontWeight = "bold";
//         }
//     };

//     const renderCell = (value, getColor) => (
//         <span style={{ color: getColor(value) }}>
//             {value}
//         </span>
//     );

//     return (
//         <>
//             <Breadcrumb current={t("Tüm Şaseler")} />

//             <>
//                 <Row className="mx-2 mb-3 card p-3">
//                     <Col md={12}>
//                         <Row>
//                             <Col md={5}>
//                                 <FormGroup
//                                     style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "1rem"
//                                     }}
//                                 >
//                                     <Label className="font-semibold">Marka</Label>
//                                     <TagBox width={"100%"}
//                                         dataSource={brands}
//                                         displayExpr="brand_name"
//                                         valueExpr="brand_name"

//                                     />
//                                 </FormGroup>
//                             </Col>
//                             <Col md={5}>
//                                 <FormGroup
//                                     style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "1rem"
//                                     }}
//                                 >
//                                     <Label className="font-semibold">Model</Label>
//                                     <TagBox width={"100%"}
//                                         dataSource={model}
//                                         displayExpr="model_name"
//                                         valueExpr="id"
//                                     />
//                                 </FormGroup>
//                             </Col>
//                             <Col md={2}
//                                 style={{
//                                     display: "flex",
//                                     justifyContent: "flex-end",
//                                 }}
//                             >
//                                 <Button
//                                     color="success"
//                                     className="d-flex align-items-center btn btn-success p-0"
//                                     onClick={getAllVehicles}
//                                     style={{
//                                         width: "90px",
//                                         height: "40px",
//                                     }}
//                                 >
//                                     <i className="fa fa-list mr-2"></i> &nbsp;
//                                     {t('Listele')}
//                                 </Button>
//                             </Col>
//                         </Row>
//                     </Col>
//                     <Col md={12}>
//                         <Row>
//                             <Col md={5}>
//                                 <FormGroup
//                                     style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "1rem"
//                                     }}
//                                 >
//                                     <Label className="font-semibold">Depo</Label>
//                                     <TagBox
//                                         width={"100%"}
//                                         dataSource={(async () => {
//                                             return await getAllWarehouses();
//                                         }
//                                         )()}
//                                     />
//                                 </FormGroup>
//                             </Col>
//                             <Col md={5}>
//                                 <FormGroup
//                                     style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "1rem"
//                                     }}
//                                 >
//                                     <Label className="font-semibold">Bölge</Label>
//                                     <TagBox width={"100%"} />
//                                 </FormGroup>
//                             </Col>
//                         </Row>
//                     </Col>
//                 </Row>
//                 <Row className="mx-2 card p-3">
//                     <DatagridCustom
//                         reff={gridRef}
//                         dataSource={dataSource}
//                         onRowPrepared={handleRowPrepared}
//                         minHeight="30vh"
//                         style={{ width: "-webkit-fill-available" }}
//                         syncLookupFilterValues={false}
//                     >
//                         <GroupPanel visible={true} />
//                         <Grouping autoExpandAll={false} expandMode="rowClick" />


//                         <Column
//                             caption={t('Oluşturma Tarihi')}
//                             dataField='create_date'
//                             alignment='center'
//                             width={152}
//                             dataType='datetime'
//                             format='dd/MM/yyyy HH:mm'
//                         />
//                         <Column
//                             caption={t('Şase')}
//                             dataField='chassis_no'
//                             alignment='center'
//                             width={173}
//                         />
//                         <Column
//                             caption={t('Milli')}
//                             dataField='Data.type'
//                             alignment='center'
//                             width={79}
//                         >
//                             <Lookup
//                                 dataSource={TYPE_LOOKUP}
//                                 displayExpr="name"
//                                 valueExpr="value"
//                             />
//                         </Column>
//                         <Column
//                             caption={t('PDI Emri')}
//                             dataField='Data.yeni/iptal'
//                             alignment='center'
//                             width={87}
//                             calculateDisplayValue={(rowData) => {
//                                 if (!rowData.Data || !rowData.Data['yeni/iptal']) return "Hayır";
//                                 switch (rowData.Data['yeni/iptal']) {
//                                     case 'YENİ': return 'Evet';
//                                     case 'IPTAL': return 'İptal';
//                                     default: return 'Hayır';
//                                 }
//                             }}
//                             calculateFilterExpression={(filterValue, selectedFilterOperation) => {
//                                 if (filterValue === "YOK") {
//                                     return data => !data.Data || !data.Data['yeni/iptal'];
//                                 }
//                                 return ['Data.yeni/iptal', '=', filterValue];
//                             }}
//                         >
//                             <Lookup
//                                 dataSource={PDI_ORDER_LOOKUP}
//                                 displayExpr="name"
//                                 valueExpr="value"
//                             />
//                         </Column>
//                         {/* Brand Column */}
//                         <Column
//                             caption={t('Marka')}
//                             dataField='Data.marka'
//                             alignment='center'
//                             calculateFilterExpression={createFilterExpression(
//                                 brands.map(b => b.brand_name),
//                                 'marka'
//                             )}
//                             cellRender={data => renderCell(
//                                 data.value,
//                                 value => brands.some(b => b.brand_name === value) ? "black" : "red"
//                             )}
//                             groupCellRender={e => renderGroupCellBrand(
//                                 e.data.items || e.data.collapsedItems,
//                                 brands
//                             )}
//                         >
//                             <Lookup
//                                 dataSource={[
//                                     ...brands,
//                                     { brand_name: "BİLİNMEYEN" },
//                                     { brand_name: "MARKA YOK" }
//                                 ]}
//                                 displayExpr="brand_name"
//                                 valueExpr="brand_name"
//                             />
//                         </Column>

//                         <Column
//                             caption={t('Car line')}
//                             dataField='Data[car line]'
//                             alignment='center'
//                         />

//                         <Column
//                             caption={t('Colour name')}
//                             dataField='Data[colour name]'
//                             alignment='center'
//                             calculateFilterExpression={createFilterExpression(
//                                 _.uniqBy(colors, "color_name").map(c => c.color_name),
//                                 'colour name'
//                             )}
//                             cellRender={data => renderCellColor(
//                                 data.value,
//                                 data.data,
//                                 colors
//                             )}
//                             groupCellRender={e => renderGroupCellColor(
//                                 'colour name',
//                                 e.data.items || e.data.collapsedItems,
//                                 colors
//                             )}
//                         >
//                             <Lookup
//                                 dataSource={[
//                                     ..._.uniqBy(colors, "color_name"),
//                                     { color_name: "BİLİNMEYEN" },
//                                     { color_name: "RENK YOK" }
//                                 ]}
//                                 displayExpr="color_name"
//                                 valueExpr="color_name"
//                             />
//                         </Column>



//                         {/* Commercial Denomination Column */}
//                         <Column
//                             caption={t('Commercial Denomination name')}
//                             dataField='Data[commercial denomination name]'
//                             alignment='center'
//                         />

//                         <Column
//                             caption={t('Commercial denomination code')}
//                             dataField='Data[commercial denomination code]'
//                             alignment='center'
//                         />

//                         {/* Summary and Toolbar */}
//                         <Summary>
//                             <GroupItem
//                                 column="chassis_no"
//                                 summaryType="count"
//                                 displayFormat="{0}"
//                             />
//                         </Summary>
//                         <Toolbar>
//                             <Item name="groupPanel" location="before" />
//                             {/* <Item>
//                             <Button onClick={getAllVehicles}>
//                                 <i className='fa fa-refresh'></i>
//                             </Button>
//                         </Item> */}
//                             <Item>
//                                 <Button
//                                     style={{ backgroundColor: "#05C851", color: "white" }}
//                                     onClick={e => ButtonOnExporting(
//                                         e,
//                                         gridRef,
//                                         `Şase Listesi - ${moment(new Date()).format("DD/MM/YYYY")}`,
//                                         "Sayfa-1"
//                                     )}
//                                 >
//                                     <i className='fa fa-file-excel-o'></i>
//                                 </Button>
//                             </Item>
//                         </Toolbar>
//                     </DatagridCustom>
//                 </Row>
//             </>
//         </>
//     );
// };

// export default VehicleList;


import { Button, TagBox } from 'devextreme-react';
import {
    Column,
    GroupItem,
    GroupPanel,
    Item,
    Lookup,
    Scrolling,
    Summary,
    Toolbar
} from 'devextreme-react/data-grid';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import Breadcrumb from '../../components/common/breadcrumb';
import DatagridCustom from '../../components/common/datagrid/custom-datagrid';
import api from '../../services/api-configuration';
import { getAllWarehouses } from '../../services/apis';
import { ButtonOnExporting } from '../../utils/DataGridExporter';
import { numberWithCommas } from '../../utils/NumberFormat';
import useFormatMessage from '../../utils/useFormatMessage';

// Constants
const TYPE_LOOKUP = [
    { value: "milli", name: "Evet" },
    { value: "ithal", name: "Hayır" }
];

const PDI_ORDER_LOOKUP = [
    { id: "Evet", name: "Evet" },
    { id: "Hayır", name: "Hayır" },
    { id: "İptal", name: "İptal" }
];
// Brand validation helper
const isBrandValid = (brandName, validBrands) => {
    return validBrands.some(b => b.brand_name === brandName);
};

// Custom hook for data management
const useVehicleData = () => {
    const [dataSource, setDataSource] = React.useState([]);
    const [brands, setBrands] = React.useState([]);
    const gridRef = useRef(null);


    const fetchBrands = async () => {
        try {
            const response = await api.post("/getAllBrands");
            setBrands(response.data.data || []);
        } catch (error) {
            const errorMessage = error.response?.data?.error || "";
            toast.error(`Markalar getirilirken hata oluştu: ${errorMessage}`);
        }
    };

    const getAllVehicles = async (filter, warehouse) => {
        console.log("Filter:", filter);
        gridRef.current.instance.beginCustomLoading();
        try {
            const response = await api.post('/vehicle/getAll', {
                warehouse_ids: filter?.warehouse === null ? warehouse.map(item => item.id) : filter?.warehouse,
                zone_ids: filter?.zone,
                model_ids: filter?.model,
                brand_ids: filter?.brand,
            });
            setDataSource(response.data || []);
        } catch (error) {
            const errorMessage = error.response?.data?.error || "";
            toast.error(`Şaseler getirilirken hata oluştu: ${errorMessage}`);
        } finally {
            gridRef.current.instance.endCustomLoading();
        }
    };

    useEffect(() => {
        fetchBrands();
    }, []);

    return { dataSource, brands, getAllVehicles, gridRef };
};

// Brand filter creator
const createBrandFilterExpression = (knownBrands) => (filterValue, selectedFilterOperation, target) => {
    if (target === 'search' && typeof filterValue === 'string') {
        return ['marka', 'contains', filterValue];
    }

    if (filterValue === "MARKA YOK") {
        return data => {
            const brandValue = data.Data?.marka;
            return !brandValue || brandValue === "" || brandValue === "null";
        };
    }

    if (filterValue === "BİLİNMEYEN") {
        return data => {
            const brandValue = data.Data?.marka;
            return brandValue && !knownBrands.includes(brandValue);
        };
    }

    return ['Data.marka', '=', filterValue];
};

// Brand cell rendering
const renderBrandCell = (value, validBrands) => {
    const color = isBrandValid(value, validBrands) ? "black" : "red";
    return <span style={{ color }}>{value || ''}</span>;
};

const renderBrandGroupCell = (items, validBrands) => {
    const firstBrand = items?.[0]?.Data?.marka || '-';
    const isValid = isBrandValid(firstBrand, validBrands);
    const count = items?.length || 0;

    return (
        <span>
            Marka: &nbsp;
            <span style={{ color: isValid ? "black" : "red" }}>
                {firstBrand}
            </span>
            ({count})
        </span>
    );
};

const VehicleList = () => {
    const { t } = useFormatMessage();
    const { dataSource, brands, getAllVehicles, gridRef } = useVehicleData();
    const [models, setModels] = React.useState([]);
    const [depo, setDepo] = React.useState([]);
    const [bolge, setBolge] = React.useState([]);
    const [filteredModels, setFilteredModels] = React.useState([]);
    const bolgeTagBoxRef = useRef(null);
    const modelTagBoxRef = useRef(null);
    const [filterValues, setFilterValues] = React.useState({
        brand: null,
        model: null,
        warehouse: null,
        zone: null
    });
    const getDepo = async () => {
        try {
            const response = await getAllWarehouses();
            const all_data = response || []

            setDepo(all_data.concat(
                //     {
                //     "address": "İSKENDERUN ANTAKYA YOLU 6 KM.FATİH MAH SOKULLU MEHMET PAŞA CAD. 46/5 SARIMAZI, 31000 BELEN/HATAY\n",
                //     "address_description": "Gemi description",
                //     "address_id": 8,
                //     "capacity": 100000,
                //     "create_date": "2024-12-03 09:36:33",
                //     "create_user_id": 318582,
                //     "discharge_area_status": false,
                //     "id": 18,
                //     "is_active": true,
                //     "tax_number": "",
                //     "tax_office": "",
                //     "warehouse_code": "D000001",
                //     "warehouse_description": "",
                //     "warehouse_name": "GEMİ",
                //     "warehouse_short_name": "GEMİ"
                // },
                {
                    "address": "İSKENDERUN ANTAKYA YOLU 6 KM.FATİH MAH SOKULLU MEHMET PAŞA CAD. 46/5 SARIMAZI, 31000 BELEN/HATAY\n",
                    "address_description": "TIR için oluşturulmuş sanal alan",
                    "address_id": 8,
                    "capacity": 100000,
                    "create_date": "2024-12-17 21:43:40",
                    "create_user_id": 3118582,
                    "discharge_area_status": false,
                    "id": 28,
                    "is_active": true,
                    "tax_number": "TIR",
                    "tax_office": "TIR",
                    "warehouse_code": "D000007",
                    "warehouse_description": "TIR",
                    "warehouse_name": "TIR",
                    "warehouse_short_name": "TIR"
                },
                // {
                //     "address": "İSKENDERUN ANTAKYA YOLU 6 KM.FATİH MAH SOKULLU MEHMET PAŞA CAD. 46/5 SARIMAZI, 31000 BELEN/HATAY\n",
                //     "address_description": "DEPO İADE",
                //     "address_id": 8,
                //     "capacity": 100000,
                //     "create_date": "2024-12-26 15:23:24",
                //     "create_user_id": 318582,
                //     "discharge_area_status": false,
                //     "id": 33,
                //     "is_active": true,
                //     "tax_number": "",
                //     "tax_office": "",
                //     "warehouse_code": "D000011",
                //     "warehouse_description": "",
                //     "warehouse_name": "DEPO İADE",
                //     "warehouse_short_name": "DEPO İADE"
                // },
                // {
                //     "address": "İSKENDERUN ANTAKYA YOLU 6 KM.FATİH MAH SOKULLU MEHMET PAŞA CAD. 46/5 SARIMAZI, 31000 BELEN/HATAY\n",
                //     "address_description": "Fabrika description",
                //     "address_id": 8,
                //     "capacity": 100000,
                //     "create_date": "2024-12-03 09:36:33",
                //     "create_user_id": 318582,
                //     "discharge_area_status": false,
                //     "id": 19,
                //     "is_active": true,
                //     "tax_number": "",
                //     "tax_office": "",
                //     "warehouse_code": "D000002",
                //     "warehouse_description": "",
                //     "warehouse_name": "FABRİKA",
                //     "warehouse_short_name": "FABRİKA"
                // },
                // {
                //     "address": "İSKENDERUN ANTAKYA YOLU 6 KM.FATİH MAH SOKULLU MEHMET PAŞA CAD. 46/5 SARIMAZI, 31000 BELEN/HATAY\n",
                //     "address_description": "BAYİ İADE",
                //     "address_id": 8,
                //     "capacity": 100000,
                //     "create_date": "2024-12-20 14:17:51",
                //     "create_user_id": 318582,
                //     "discharge_area_status": false,
                //     "id": 29,
                //     "is_active": true,
                //     "tax_number": "",
                //     "tax_office": "",
                //     "warehouse_code": "D000008",
                //     "warehouse_description": "",
                //     "warehouse_name": "BAYİ İADE",
                //     "warehouse_short_name": "BAYİ İADE"
                // }
            ))
        } catch (error) {
            const errorMessage = error.response?.data?.error || "";
            toast.error(t('Depolar getirilirken hata oluştu') + ":" + errorMessage);
        }
    }

    const getBolge = async (ids) => {
        try {
            // Tüm ID'ler için Promise'leri oluştur
            const promises = ids.map(id =>
                api.post("/zone/getZonesByWarehouse", { warehouse_id: id })
            );

            // Tüm istekleri parallel olarak çalıştır
            const responses = await Promise.all(promises);

            // Tüm responseları tek bir dizide topla
            const allZones = responses.reduce((acc, response) => {
                const zones = response.data.data || [];
                return [...acc, ...zones];
            }, []);

            setBolge(allZones);
        }
        catch (error) {
            const errorMessage = error.response?.data?.error || "";
            toast.error(t('Bölgeler getirilirken hata oluştu') + ":" + errorMessage);
        }
    }

    const fetchModels = async () => {
        try {
            const response = await api.post("/getAllModels");
            setModels(response.data.data || []);
        } catch (error) {
            const errorMessage = error.response?.data?.error || "";
            toast.error(t('Modeller getirilirken hata oluştu') + ":" + errorMessage);
        }
    };

    useEffect(() => {
        getDepo();
        fetchModels();
    }, []);

    const handleRowPrepared = (e) => {
        if (e.rowType === "group" && e.values[e.groupIndex] === "") {
            e.rowElement.hidden = true;
            if (!e.isExpanded) e.component.expandRow(e.key);
        }
    };

    const [visibleRowCount, setVisibleRowCount] = useState(0);

    // Add handler for the DataGrid's onContentReady event
    const handleContentReady = (e) => {
        const dataGrid = e.component;
        // Get the total count of rows after applying filters

        const filteredRowCount = dataGrid.totalCount();
        if (document.getElementById("total-count")) {
            document.getElementById("total-count").innerText = numberWithCommas(filteredRowCount);
        }


    };

    return (
        <>
            <Breadcrumb current={t("Stok İzleme")} />
            <Row className="mx-2 mb-3 card p-3">
                <Col md={12}>
                    <Row>
                        <Col md={5}>
                            <FormGroup className="d-flex align-items-center gap-3">
                                <Label className="font-semibold mr-3">Marka</Label>
                                <TagBox
                                    searchEnabled={true}
                                    width="100%"
                                    dataSource={brands}
                                    displayExpr="brand_name"
                                    maxDisplayedTags={3}
                                    showSelectionControls={true}
                                    id='brand_tagbox'
                                    onValueChange={(e) => {
                                        let selectedBrands = e.map((item) => item.id);
                                        setFilterValues({ ...filterValues, brand: selectedBrands?.length > 0 ? selectedBrands : null });
                                        const filteredModels = models.filter(model => selectedBrands.includes(model.brand_id));
                                        setFilteredModels(filteredModels);

                                        if (modelTagBoxRef.current) {
                                            modelTagBoxRef.current.instance.reset(); // Modeli sıfırla
                                        }
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup className="d-flex align-items-center gap-3">
                                <Label className="font-semibold mr-3">Model</Label>
                                <TagBox
                                    maxDisplayedTags={3}
                                    showSelectionControls={true}
                                    searchEnabled={true}
                                    width="100%"
                                    dataSource={filteredModels}
                                    displayExpr={(item) => item.model_code + " " + item.model_name + " (" + item.brand_name + ")"}
                                    id='model_tagbox'
                                    onValueChange={(e) => {
                                        let selectedModels = e.map((item) => item.id);
                                        setFilterValues({ ...filterValues, model: selectedModels?.length > 0 ? selectedModels : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2} className="d-flex justify-content-end">
                            <Button
                                color="success"
                                disabled={depo.length === 0}
                                className="d-flex align-items-center p-0 btn btn-success"
                                onClick={() => getAllVehicles(filterValues, depo)}
                                style={{ width: "90px", height: "40px" }}
                            >
                                <i className="fa fa-list mr-2"></i>
                                {t('Listele')}
                            </Button>
                        </Col>
                    </Row>

                </Col>
                <Col md={12}>
                    <Row>
                        <Col md={5}>
                            <FormGroup className="d-flex align-items-center gap-3">
                                <Label className="font-semibold mr-3">Depo</Label>
                                <TagBox
                                    maxDisplayedTags={3}
                                    showSelectionControls={true}
                                    searchEnabled={true}
                                    width="100%"
                                    id='depo_tagbox'
                                    dataSource={
                                        depo
                                    }
                                    displayExpr={(e) => e.warehouse_name === "TIR" ? "TIR (Taşıma Durumunda)" : e.warehouse_name}
                                    onValueChange={(e) => {
                                        let selectedDepo = e.map((item) => item.id);
                                        if (bolgeTagBoxRef.current) {
                                            bolgeTagBoxRef.current.instance.reset(); // Bölgeyi sıfırla
                                        }

                                        // Depo işlemlerini yap
                                        getBolge(selectedDepo);
                                        setFilterValues({
                                            ...filterValues,
                                            warehouse: selectedDepo?.length > 0 ? selectedDepo : null,
                                        });

                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup className="d-flex align-items-center gap-3">
                                <Label className="font-semibold mr-3">Bölge</Label>
                                <TagBox width="100%"
                                    maxDisplayedTags={3}
                                    showSelectionControls={true}
                                    searchEnabled={true}
                                    id='bolge_tagbox'
                                    ref={bolgeTagBoxRef}
                                    dataSource={bolge}
                                    keyExpr="id"
                                    displayExpr={(e) => {
                                        return e.zone_name + " (" + e.warehouse_name + ")"
                                    }}
                                    onValueChange={(e) => {
                                        let selectedBolge = e.map((item) => item.id);
                                        setFilterValues({ ...filterValues, zone: selectedBolge?.length > 0 ? selectedBolge : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Col>

                <Col
                    sm={12}
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        marginTop: "1rem",
                    }}
                >

                    <b> TOPLAM:
                        &nbsp;
                        <span id='total-count' >

                        </span>
                    </b>
                </Col>
            </Row>
            <Row className="mx-2 card p-3">
                <DatagridCustom
                    reff={gridRef}
                    syncLookupFilterValues={true}
                    dataSource={dataSource}
                    onRowPrepared={handleRowPrepared}
                    onContentReady={handleContentReady}
                    height="60vh"
                    style={{
                        width: "-webkit-fill-available",
                        height: "60vh"
                    }}
                >
                    <GroupPanel visible={true} />
                    <Column
                        caption={t('Oluşturma Tarihi')}
                        dataField='create_date'
                        alignment='center'
                        width={152}
                        dataType='datetime'
                        format='dd/MM/yyyy HH:mm'
                    />
                    <Column
                        caption={t('Şase')}
                        dataField='chassis_no'
                        alignment='center'
                        width={173}
                    />
                    <Column
                        caption={t('Milli')}
                        dataField='Data.type'
                        alignment='center'
                        width={79}
                    >
                        <Lookup
                            dataSource={TYPE_LOOKUP}
                            displayExpr="name"
                            valueExpr="value"
                        />
                    </Column>
                    <Column
                        caption={t('PDI Emri')}
                        dataField='Data.yeni/iptal'
                        alignment='center'
                        width={87}
                        lookup={{
                            dataSource: {
                                store: [{
                                    id: 'YENİ',
                                    name: 'Evet'
                                }, {
                                    id: 'İPTAL',
                                    name: 'Hayır'
                                }],
                                paginate: false
                            },
                            valueExpr: 'id',
                            displayExpr: 'name'
                        }}
                        calculateCellValue={(rowData) => {
                            if (!rowData.Data?.['yeni/iptal']) return 'İPTAL';
                            return rowData.Data['yeni/iptal'] === 'YENİ' ? 'YENİ' : 'İPTAL';
                        }}
                    />
                    {/* PDI -> Data.pdi_exit: 1 */}
                    <Column
                        caption={t('PDI')}
                        dataField='Data.pdi_exit'
                        alignment='center'
                        width={87}
                        lookup={{
                            dataSource: {
                                store: [{
                                    id: 1,
                                    name: 'Evet'
                                }, {
                                    id: 0,
                                    name: 'Hayır'
                                }],
                                paginate: false
                            },
                            valueExpr: 'id',
                            displayExpr: 'name'
                        }}
                        calculateCellValue={(rowData) => {
                            return rowData.Data?.pdi_exit === 1 ? 1 : 0;
                        }}
                    />
                    <Column
                        caption='Fatura'
                        dataField='invoice'
                        alignment='center'
                        width={87}
                        lookup={{
                            dataSource: {
                                store: [{
                                    id: true,
                                    name: 'Var'
                                }, {
                                    id: false,
                                    name: 'Yok'
                                }],
                                paginate: false
                            },
                            valueExpr: 'id',
                            displayExpr: 'name'
                        }}
                        calculateCellValue={(rowData) => {
                            return rowData.invoice === true ? true : false;
                        }}
                    />
                    <Column
                        caption={t('Marka')}
                        dataField='brand'
                        alignment='center'
                        calculateFilterExpression={createBrandFilterExpression(brands.map(b => b.brand_name))}
                        cellRender={data => {
                            if (data.data.brand === null) return <span style={{ color: "red" }}>{data.data.Data.marka}</span>;
                            return data.value
                        }}
                        groupCellRender={e => renderBrandGroupCell(
                            e.data.items || e.data.collapsedItems,
                            brands
                        )}
                    >
                        <Lookup
                            dataSource={[
                                ...brands,
                                { brand_name: "BİLİNMEYEN" },
                                { brand_name: "MARKA YOK" }
                            ]}
                            displayExpr="brand_name"
                            valueExpr="brand_name"
                        />
                    </Column>
                    <Column
                        caption={t('Model')}
                        dataField='model'
                        alignment='center'
                    />

                    <Column
                        caption={t('Renk')}
                        dataField='color'
                        alignment='center'
                    />
                    <Column caption="Adres" dataField="address_info" alignment="center" />
                    {/*  <Column caption="Gemi Varış Tarihi" dataField="Data.gemi varış tarihi" alignment="center"
                        dataType='date'
                    /> */}
                    <Scrolling mode='infinte' />
                    <Summary>
                        <GroupItem
                            column="chassis_no"
                            summaryType="count"
                            displayFormat="{0}"
                        />
                    </Summary>
                    <Toolbar>
                        <Item name="groupPanel" location="before" />
                        <Item>
                            <Button
                                style={{ backgroundColor: "#05C851", color: "white" }}
                                onClick={e => ButtonOnExporting(
                                    e,
                                    gridRef,
                                    `Şase Listesi - ${moment(new Date()).format("DD/MM/YYYY")}`,
                                    "Sayfa-1"
                                )}
                            >
                                <i className='fa fa-file-excel-o'></i>
                            </Button>
                        </Item>
                    </Toolbar>
                </DatagridCustom>

            </Row>
        </>
    );
};

export default VehicleList;